// src/utils/format.ts

/**
 * Para formatı - Tutarlı format için tek fonksiyon
 * Her zaman en-US formatı kullanır (nokta ondalık ayracı)
 */
// ============================================================
// GİZLİLİK MODU — para maskelemesinin TEK MERKEZİ
// Hesabı çalışan da kullanabildiği için, patron gizlilik modunu açtığında
// paneldeki tüm tutarlar maskelenir. Panelde 3 ayrı formatCurrency kopyası
// vardı; diğer ikisi artık BURAYA delege eder → hiçbir ekranda tutar sızmaz.
// Değer localStorage'dan SENKRON okunur; böylece ilk render'da bile maske
// hazırdır (veri bir an görünüp kaybolmaz). Sunucudan gelen taze değer ezer.
// ============================================================
export const PRIVACY_MASK = '••••'
const PRIVACY_LS_KEY = 'ebh_privacy_mode'

let _panelMasked = (() => {
  try {
    const m = localStorage.getItem(PRIVACY_LS_KEY)
    return m === 'panel' || m === 'both'
  } catch { return false }
})()

/** Panelde para maskelensin mi (mod: panel | both). */
export const isPanelMasked = (): boolean => _panelMasked

/** Sunucudan gelen gizlilik modunu uygula (panel | both → maskele). */
export const applyPrivacyMode = (mode: string | null | undefined): void => {
  const m = (mode || 'none').toLowerCase()
  _panelMasked = m === 'panel' || m === 'both'
  try { localStorage.setItem(PRIVACY_LS_KEY, m) } catch { /* yoksay */ }
}

export const formatCurrency = (
  amount: number | null | undefined,
  currency: string = 'USD'
): string => {
  if (_panelMasked) return PRIVACY_MASK

  if (amount === null || amount === undefined || isNaN(amount)) {
    return '$0.00'
  }

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount)
}

/**
 * Sayı formatı - Virgülsüz
 */
export const formatNumber = (num: number | null | undefined): string => {
  if (num === null || num === undefined || isNaN(num)) {
    return '0'
  }
  return num.toLocaleString('en-US')
}

/**
 * Tarih formatı - Türkçe
 */
export const formatDate = (dateString: string | null): string => {
  if (!dateString) return 'Tarih yok'
  
  try {
    return new Date(dateString).toLocaleDateString('tr-TR', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    })
  } catch {
    return 'Geçersiz tarih'
  }
}